/* eslint-disable prettier/prettier */
import { AINotesGenerateNoteEnum } from 'types';

export const aiNotesGenerateNoteOptions: Array<{ id: string; value: string; translationKey: string }> = [
  {
    id: AINotesGenerateNoteEnum.BIRP.toString(),
    value: 'BIRP',
    translationKey: 'birp',
  },
  {
    id: AINotesGenerateNoteEnum.CARE.toString(),
    value: 'CARE',
    translationKey: 'care',
  },
  {
    id: AINotesGenerateNoteEnum.DAP.toString(),
    value: 'DAP',
    translationKey: 'dap',
  },
  {
    id: AINotesGenerateNoteEnum.FORT.toString(),
    value: 'FORT',
    translationKey: 'fort',
  },
  {
    id: AINotesGenerateNoteEnum.GIRP.toString(),
    value: 'GIRP',
    translationKey: 'girp',
  },
  {
    id: AINotesGenerateNoteEnum.MINT.toString(),
    value: 'MINT',
    translationKey: 'mint',
  },
  {
    id: AINotesGenerateNoteEnum.PIRP.toString(),
    value: 'PIRP',
    translationKey: 'pirp',
  },
  {
    id: AINotesGenerateNoteEnum.SIRP.toString(),
    value: 'SIRP',
    translationKey: 'sirp',
  },
  {
    id: AINotesGenerateNoteEnum.PIE.toString(),
    value: 'PIE',
    translationKey: 'pie',
  },
  {
    id: AINotesGenerateNoteEnum.RIFT.toString(),
    value: 'RIFT',
    translationKey: 'rift',
  },
  {
    id: AINotesGenerateNoteEnum.SOAP.toString(),
    value: 'SOAP',
    translationKey: 'soap',
  },
  {
    id: AINotesGenerateNoteEnum.STOP.toString(),
    value: 'STOP',
    translationKey: 'stop',
  },
  {
    id: AINotesGenerateNoteEnum.Intake.toString(),
    value: 'Intake',
    translationKey: 'intake',
  },
  {
    id: AINotesGenerateNoteEnum.Group.toString(),
    value: 'Group',
    translationKey: 'group',
  },
  {
    id: AINotesGenerateNoteEnum.Couples.toString(),
    value: 'Couples',
    translationKey: 'couples',
  },
  {
    id: AINotesGenerateNoteEnum.Psychotherapy.toString(),
    value: 'Psychotherapy',
    translationKey: 'psychotherapy',
  },
];
